'use strict';

var _classCallCheck = require("C:\\originatorx-admin\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\originatorx-admin\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\originatorx-admin\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\originatorx-admin\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\originatorx-admin\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var Transform = require('stream').Transform;

var isNode = require('detect-node');

var isSource = require('is-pull-stream').isSource;

var toStream = require('pull-stream-to-stream');

var PADDING = '--';
var NEW_LINE = '\r\n';
var NEW_LINE_BUFFER = Buffer.from(NEW_LINE);

var Multipart = /*#__PURE__*/function (_Transform) {
  _inherits(Multipart, _Transform);

  function Multipart(options) {
    var _this;

    _classCallCheck(this, Multipart);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Multipart).call(this, Object.assign({}, options, {
      objectMode: true,
      highWaterMark: 1
    })));
    _this._boundary = _this._generateBoundary();
    _this._files = [];
    _this._draining = false;
    return _this;
  }

  _createClass(Multipart, [{
    key: "_flush",
    value: function _flush() {
      this.push(Buffer.from(PADDING + this._boundary + PADDING + NEW_LINE));
      this.push(null);
    }
  }, {
    key: "_generateBoundary",
    value: function _generateBoundary() {
      var boundary = '--------------------------';

      for (var i = 0; i < 24; i++) {
        boundary += Math.floor(Math.random() * 10).toString(16);
      }

      return boundary;
    }
  }, {
    key: "_transform",
    value: function _transform(file, encoding, callback) {
      if (Buffer.isBuffer(file)) {
        this.push(file);
        return callback(); // early
      } // not a buffer, must be a file


      this._files.push(file);

      this._maybeDrain(callback);
    }
  }, {
    key: "_maybeDrain",
    value: function _maybeDrain(callback) {
      var _this2 = this;

      if (!this._draining) {
        if (this._files.length) {
          this._draining = true;

          var file = this._files.shift();

          this._pushFile(file, function (err) {
            _this2._draining = false;

            if (err) {
              _this2.emit('error', err);
            } else {
              _this2._maybeDrain(callback);
            }
          });
        } else {
          this.emit('drained all files');
          callback();
        }
      } else {
        this.once('drained all files', callback);
      }
    }
  }, {
    key: "_pushFile",
    value: function _pushFile(file, callback) {
      var _this3 = this;

      var leading = this._leading(file.headers || {});

      this.push(leading);
      var content = file.content || Buffer.alloc(0);

      if (Buffer.isBuffer(content)) {
        this.push(content);
        this.push(NEW_LINE_BUFFER);
        return callback(); // early
      }

      if (isSource(content)) {
        content = toStream.source(content);
      } // From now on we assume content is a stream


      content.once('error', this.emit.bind(this, 'error'));
      content.once('end', function () {
        _this3.push(NEW_LINE_BUFFER);

        callback(); // TODO: backpressure!!! wait once self is drained so we can proceed
        // This does not work
        // this.once('drain', () => {
        //   callback()
        // })
      });
      content.on('data', function (data) {
        var drained = _this3.push(data); // Only do the drain dance on Node.js.
        // In browserland, the underlying stream
        // does NOT drain because the request is only sent
        // once this stream ends.


        if (!drained && isNode) {
          content.pause();

          _this3.once('drain', function () {
            return content.resume();
          });
        }
      });
    }
  }, {
    key: "_leading",
    value: function _leading(headers) {
      var leading = [PADDING + this._boundary];
      Object.keys(headers).forEach(function (header) {
        leading.push(header + ': ' + headers[header]);
      });
      leading.push('');
      leading.push('');
      var leadingStr = leading.join(NEW_LINE);
      return Buffer.from(leadingStr);
    }
  }]);

  return Multipart;
}(Transform);

module.exports = Multipart;